module.exports = __webpack_public_path__ + "static/media/whichThinnerTableBelow.ea4bef96.mp3";